var Component = require("!../_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./swiper.vue"),
  /* template */
  require("!!../_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8255900e\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./swiper.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue-awesome-swiper@2.5.4@vue-awesome-swiper/swiper.vue
// module id = 161
// module chunks = 1